<template>
    <div class="modal is-active">
        <div class="modal-content has-custom-scroll">
            <slot></slot>
        </div>
        <div class="modal-background"></div>
    </div>
</template>